<template>
  <div :key="$route.fullPath" class="hello">
    <header-title v-bind:title_img_src="title_img" />
    <nav-bar></nav-bar>
    <div v-if="user" style="margin:40px;">
      <div>
        <User :user_id="forUserId"></User>
        <br/><br/>
      </div>

      <div v-if="processing">
        Processing...<br/><br/>
        <svg class="spinner" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <circle class="cspin" cx="50" cy="50" r="45"/>
        </svg>
      </div>

      <div v-else> 
        <div v-if="tsxError">Sorry, there was an error with your order.<br/><br/>{{tsxError}}</div>
        <div v-else-if="tsxSuccess">
          Thanks for donating!<br/><br/>
          <table v-if="donation" border="1" style="margin-left:auto;margin-right:auto;">
            <tr><td>Order ID</td><td>{{donation.order_id}}</td></tr>
            <tr><td>Amount</td><td>${{donation.amount}}</td></tr>
          </table>
        </div>
        <div v-else>
          <div class="package-select" style="display:none;">
            <span>
              <input type="radio" id="pkg0" value="0" v-model="selectedPackage">
              <br/><label :class="{'btn-enabled':true, 'btn-top':true, 'btn-selected':selectedPackage === '0'}" for="pkg0">Save Token</label>
            </span>
            <span>
              <input type="radio" id="pkg1" value="1" v-model="selectedPackage">
              <br/><label :class="{'btn-enabled':true, 'btn-top':true, 'btn-selected':selectedPackage === '1'}" for="pkg1">Kill Token</label>
            </span>
            <span>
              <input type="radio" id="pkg2" value="2" v-model="selectedPackage">
              <br/><label :class="{'btn-enabled':true, 'btn-top':true, 'btn-selected':selectedPackage === '2'}" for="pkg2">Donate</label>
            </span>
          </div>
          <div>
            <div style="font-size:20px;font-weight:bold;">Thanks for considering a donation to the Bald man - any donation below $5 up will pop your message up on the screen when he’s live! You can buy Gold for Sellout games HERE</div>
            <br/>
          </div>
          <div style="font-size:30px;font-weight:bold;">Donate ${{cost}}!</div>
          <span v-if="hasMessage">
            <br/>
            <textarea class="messagetext" v-model="message" placeholder="Your Message Here!"></textarea>
          </span>
          <div style="margin-left: auto;
        margin-right: auto; margin-top:10px;">
            <vue-slider 
            :min="1"
            :max="sliderMax"
            :interval="interval" 
            :adsorb="true"
            v-model="quantity" /><br/>
            <span v-bind:key="buttonQuantity" v-for="buttonQuantity in buttonAmounts">
              <button-a v-on:clicked="changeQuantity(buttonQuantity)" :selected="buttonQuantity === quantity" style="font-size: 40px; padding: 8px;">{{buttonLabel(buttonQuantity)}}</button-a>
            </span>
            <span><login-btn buttonClass="btn-enabled" style="font-size: 40px; padding: 8px;" v-if="!currentUser">Login for more options!</login-btn></span>
          </div>
          <br/><br/>
          <div id="paypal-button-container"></div>
        </div>
      </div>
    </div>
    <div v-else>
      <span v-if="currentUser">Unknown User<br/>Were you trying to donate to someone else?</br><br/><h1>If you want to donate on behalf of yourself <router-link to="/donate">CLICK HERE</router-link></h1></span>
      <span v-else><login-btn buttonClass="btn-enabled" style="font-size: 40px; padding: 8px;">Login to donate!</login-btn></span>
    </div>
  </div>
</template>

<script>
import User from './User'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
import Vue from 'vue'
import { mapState } from 'vuex'

let scriptLoaded = false
let scriptFinished = false

let packages = [
  // {
  //   name: 'Save Token',
  //   denomination: 'Save Tokens',
  //   quantityButtons: [1, 2, 3, 4, 5, 7, 10, 15, 20, 30, 40, 50],
  //   interval: 1,
  //   authThreshold: 10,
  //   maxQuantity: 10,
  //   authMaxQuantity: 50,
  //   cost: (qty) => {
  //     return qty * 10
  //   },
  //   sku: 'SAVETOKEN'
  // },
  // {
  //   name: 'Kill Token',
  //   denomination: 'Kill Tokens',
  //   quantityButtons: [1, 2, 3, 4, 5, 6, 7, 8],
  //   interval: 1,
  //   authThreshold: 2,
  //   cost: (qty) => {
  //     return (qty * 66).toFixed(2)
  //   },
  //   maxQuantity: 2,
  //   authMaxQuantity: 8,
  //   sku: 'KILLTOKEN'
  // },
  {
    name: 'Donation',
    denomination: 'bars',
    quantityButtons: [1, 2, 4, 7, 10, 15, 20, 30, 40, 60, 80, 100],
    interval: 1,
    authThreshold: 20,
    cost: (qty) => {
      return qty * 5
    },
    sku: 'DONATE',
    hasMessage: true
  }
]

/* global paypal */

export default {
  name: 'donate',
  props: ['user_id'],
  components: {
    VueSlider,
    User
  },
  data () {
    return {
      title_img: 'swiftorland-title.svg',
      displayAmount: 5,
      tsxSuccess: false,
      tsxError: undefined,
      processing: false,
      donation: {},
      baseButtonAmounts: [5, 10, 25, 50, 66, 75, 100],
      additionalButtonAmounts: [150, 200, 300, 400, 500],
      paypalDisplayed: false,
      message: '',
      quantity: 1,
      selectedPackage: '0'
    }
  },
  computed: Object.assign(mapState([
    'currentUser'
  ]), {
    // amount () {
    //   return this.convertToMoney(this.displayAmount)
    // },
    buttonAmounts () {
      if (this.currentUser) {
        return this.package.quantityButtons
      } else {
        return this.package.quantityButtons.filter(b => b <= this.authThreshold)
      }
    },
    sliderMax () {
      return this.currentUser ? this.authMaxQuantity : this.maxQuantity
    },
    user () {
      if (this.user_id) {
        return this.$store.state.users[this.user_id.toLowerCase()]
      } else {
        return this.currentUser
      }
    },
    forUserId () {
      if (this.user_id) {
        return this.user_id
      } else {
        return this.currentUser ? this.currentUser.id : undefined
      }
      // return this.user_id ? this.user_id.toLowerCase() : this.currentUser.id
    },
    cost () {
      // return Math.round(parseInt(this.amount) / 5)
      return this.package.cost(this.quantity)
    },
    package () {
      return packages[parseInt(this.selectedPackage)]
    },
    name () {
      return this.package.name
    },
    denomination () {
      return this.package.denomination
    },
    authThreshold () {
      return this.package.authThreshold
    },
    interval () {
      return this.package.interval || 1
    },
    authMaxQuantity () {
      return this.package.authMaxQuantity || 100
    },
    maxQuantity () {
      return this.package.maxQuantity || 20
    },
    sku () {
      return this.package.sku
    },
    hasMessage () {
      return this.package.hasMessage || false
    }
  }),
  watch: {
    async user () {
      await Vue.nextTick()
      this.displayPaypal()
    },
    '$route.path' (to, from) {
    },
    selectedPackage () {
      this.quantity = 1
    }
  },
  updated () {
    this.displayPaypal()
  },
  destroyed () {
  },
  mounted () {
    if (this.user) {
      this.displayPaypal()
    }
  },
  created: function () {
    if (!scriptLoaded) {
      this.$store.dispatch('fetchUser', this.user_id)
      let paypalScript = document.createElement('script')
      paypalScript.setAttribute('src', `https://www.paypal.com/sdk/js?client-id=${Vue.config.PAYPAL_CLIENT_ID}&disable-funding=credit`)
      document.head.appendChild(paypalScript)

      paypalScript.onload = () => {
        scriptFinished = true

        this.displayPaypal()
      }

      scriptLoaded = paypalScript
    }

    this.paypalScript = scriptLoaded
  },
  methods: {
    buttonLabel (qty) {
      // return `${qty} for $${this.costFor(qty)}`
      return `$${this.costFor(qty)}`
    },
    costFor (qty) {
      return this.package.cost(qty)
    },
    convertToMoney (amt) {
      return amt.toString().includes('.') ? amt : `${amt}.00`
    },
    displayPaypal () {
      if (!this.user || !scriptFinished || this.paypalDisplayed || !this.paypalScript) { return } else { this.paypalDisplayed = true }

      paypal.Buttons({
        createOrder: (data, actions) => {
          return actions.order.create({
            application_context: {shipping_preference: 'NO_SHIPPING'},
            purchase_units: [{
              reference_id: `${this.sku}_${this.forUserId}`,
              amount: {
                value: `${this.cost}`
              }
            }]
          })
        },
        onApprove: async (data, actions) => {
          this.processing = true
          let result = await this.$store.dispatch('captureDonation', {orderId: data.orderID, message: this.message})
          this.processing = false
          if (!result || result.error) {
            this.tsxError = result.error.data ? result.error.data : result.error
          } else {
            this.tsxSuccess = true
            this.donation = result.donation

            let sku = 'UNKNOWN'
            if (this.donation.reference_id) {
              sku = this.donation.reference_id.split('_')[0]
            }
            this.$gtag.query('event', 'purchase', {
              'transaction_id': this.donation.order_id,
              'affiliation': 'Donation Page',
              'value': parseFloat(this.donation.amount),
              'currency': 'USD',
              'items': [
                {
                  'item_id': sku,
                  'item_name': sku
                }
              ]
            })
          }
        }
      }).render('#paypal-button-container')
    },
    changeQuantity (qty) {
      this.quantity = qty
    }
  }
}
</script>

<style scoped>
.package-select {
  display: grid;
  grid-template-columns: auto auto auto;
  justify-content: space-around;
  min-height: 35px;
  min-width: 200px;
  max-width: 500px;
  width: 100%;
  margin-left:auto;
  margin-right:auto;
  margin-bottom: 60px;
}
.package-select input[type="radio"] {
  opacity: 0;
  position: fixed;
  width: 0;
}
.package-select span {
  /* margin: 40px; */
}
.package-select label {
  font-size: 30px;
  font-weight: bold;
}
.btn-enabled{
    display: inline-block;
    border-top: 4px #b62626 solid;
    padding: 5px;
    border-radius: 4px;
    box-shadow: 0px 3px 3px 3px rgba(0, 0, 0, 0.4);
    transition: background-color 0.2s , border-color 0.2s;
    margin: 5px;
    min-width: 50px;
    user-select: none;
    cursor: pointer;
    color:white;
}

.btn-top{
    width:200px;
}
.btn-enabled:hover{
    background-color: #b62626;
    border-top: 4px rgb(255, 0, 0) solid;
}
.btn-selected{
  background-color: #b62626;
    border-top: 4px rgb(255, 0, 0) solid;
}
#paypal-button-container {
  margin: 0 auto;
  width: 500px;
}

.spinner {
  animation: 2s linear infinite svg-animation;
  max-width: 100px;
}

@keyframes svg-animation {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg)
  }
}

.messagetext {
  min-height: 35px;
  min-width: 200px;
  max-width: 750px;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  font-size: 20px;
  display: inline-block;
  width: 100%;
}

.cspin {
  animation: 1.4s ease-in-out infinite both circle-animation;
  display: block;
  fill: transparent;
  stroke: #2f3d4c;
  stroke-linecap: round;
  stroke-dasharray: 283;
  stroke-dashoffset: 280;
  stroke-width: 10px;
  transform-origin: 50% 50%;
}

@keyframes circle-animation {
  0%,
  25% {
    stroke-dashoffset: 280;
    transform: rotate(0);
  }
  
  50%,
  75% {
    stroke-dashoffset: 75;
    transform: rotate(45deg);
  }
  
  100% {
    stroke-dashoffset: 280;
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Donate.vue